// src/components/ClientSelector.jsx
import React from 'react';
import './ClientSelector.css'; // 🔁 Tu dois créer ce fichier CSS

const themes = Array.from({ length: 10 }, (_, i) => `theme${i + 1}`);

export default function ClientSelector({ current, onChange }) {
  return (
    <div className="theme-selector-dev">
      <label className="theme-selector-label">Client / Thème :</label>
      <select
        value={current}
        onChange={(e) => onChange(e.target.value)}
        className="theme-selector-select"
      >
        {themes.map((theme) => (
          <option key={theme} value={theme}>
            {theme}
          </option>
        ))}
      </select>
    </div>
  );
}
